import { Box } from '@mui/material'
import { LoadingContainer } from '@/components/feedbacks/LoadingContainer'
import { useSearch } from '@/features/search/hooks/useSearch'
import { CardGrid } from './CardGrid'
import { CardPagination } from './CardPagination'
import { CardViewFooter } from './CardViewFooter'

export const CardView = () => {
  const { searchResults } = useSearch()
  const { rows, request } = searchResults

  return (
    <>
      <LoadingContainer loading={request.isFetching}>
        <Box flexShrink={1}>
          <CardGrid rows={rows} />
        </Box>
      </LoadingContainer>
      <CardViewFooter>
        <CardPagination />
      </CardViewFooter>
    </>
  )
}
